import { render, staticRenderFns } from "./CartoesEstorno.vue?vue&type=template&id=23572c6e&scoped=true&"
import script from "./CartoesEstorno.vue?vue&type=script&lang=js&"
export * from "./CartoesEstorno.vue?vue&type=script&lang=js&"
import style0 from "./CartoesEstorno.vue?vue&type=style&index=0&id=23572c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23572c6e",
  null
  
)

export default component.exports